module.exports = __webpack_public_path__ + "static/media/prizes-fr.5c7447b2.png";